import React from "react";
import { Col } from "react-bootstrap";

// Lazy load to avoid circular dependency in @rjsf/core
let retrieveSchema = null;

function getRetrieveSchema() {
    if (!retrieveSchema) {
        retrieveSchema = require("@rjsf/core/lib/utils").retrieveSchema;
    }
    return retrieveSchema;
}

// Code originally lifted from the old, neglected, unmaintained & abandoned https://github.com/audibene-labs/react-jsonschema-form-layout
// then made to work in 2021
class LayoutFieldBase extends React.Component {
    // These methods are copied from ObjectField to avoid extending it at module load time
    isRequired(name) {
        const schema = this.props.schema;
        return Array.isArray(schema.required) && schema.required.indexOf(name) !== -1;
    }

    onPropertyChange = name => {
        return (value, errorSchema) => {
            const newFormData = { ...this.props.formData, [name]: value };
            this.props.onChange(
                newFormData,
                errorSchema &&
                    this.props.errorSchema && {
                        ...this.props.errorSchema,
                        [name]: errorSchema
                    }
            );
        };
    };

    render() {
        const { uiSchema, errorSchema, idSchema, required, disabled, readonly, onFocus, onBlur, formData, registry } =
            this.props;
        const { definitions, fields, formContext } = registry;
        const { SchemaField, TitleField, DescriptionField } = fields;
        const schema = getRetrieveSchema()(this.props.schema, definitions);
        const { title = "", description = "", properties = {} } = schema;

        const layoutSpecifications = uiSchema["ui:layout"];
        const flatLayout = layoutSpecifications.reduce((a, o) => a.concat(Object.keys(o)), []);
        const extraProperties = Object.keys(properties).filter(x => !flatLayout.includes(x));
        const extraLayout = extraProperties.map(x => ({ [x]: {} }));
        const layout = [...layoutSpecifications, ...extraLayout];

        return (
            <fieldset className="uiLayout">
                {title ? (
                    <TitleField
                        id={`${idSchema.$id}__title`}
                        title={title}
                        required={required}
                        formContext={formContext}
                    />
                ) : null}
                {description ? (
                    <DescriptionField
                        id={`${idSchema.$id}__description`}
                        description={description}
                        formContext={formContext}
                    />
                ) : null}
                {layout.map((row, index) => (
                    <div className="row" key={index}>
                        {Object.keys(row).map((name, index) => {
                            const { doShow, ...rowProps } = row[name];
                            const style = doShow && !doShow({ formData }) ? { display: "none" } : {};
                            if (properties[name]) {
                                return (
                                    <Col {...rowProps} key={index} style={style}>
                                        <SchemaField
                                            name={name}
                                            required={this.isRequired(name)}
                                            schema={properties[name]}
                                            uiSchema={uiSchema[name]}
                                            errorSchema={errorSchema[name]}
                                            idSchema={idSchema[name]}
                                            formData={formData[name]}
                                            onChange={this.onPropertyChange(name)}
                                            onFocus={onFocus}
                                            onBlur={onBlur}
                                            registry={registry}
                                            disabled={disabled}
                                            readonly={readonly}
                                        />
                                    </Col>
                                );
                            } else {
                                const { render, ...rowProps } = row[name];
                                const UIComponent = render ? render : () => null;

                                return (
                                    <Col {...rowProps} key={index} style={style}>
                                        <UIComponent
                                            name={name}
                                            formData={formData}
                                            errorSchema={errorSchema}
                                            uiSchema={uiSchema}
                                            schema={schema}
                                            registry={registry}
                                        />
                                    </Col>
                                );
                            }
                        })}
                    </div>
                ))}
            </fieldset>
        );
    }
}

export { LayoutFieldBase as LayoutField };
